import { type FC } from "react";

import { ColoredLabel } from "widgets";

import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";

const PlaybookStatusCell: FC<IAgGridCellProps> = (props) => {
  if (props.value == null) {
    return null;
  }

  return (
    <TableCell>
      {props.value ? (
        <ColoredLabel color={"#98C375"}>Enabled</ColoredLabel>
      ) : (
        <ColoredLabel color={"#CB5271"}>Disabled</ColoredLabel>
      )}
    </TableCell>
  );
};

export default PlaybookStatusCell;
